import dayjs, { Dayjs } from 'dayjs';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import { SxProps, Theme } from '@mui/system';

import Badge from '@mui/material/Badge';
import { sizeBoxCalendar, sizeBoxCalendarSelected } from 'src/components/calendar/styles';

const ServerDay = (props: any & { highlightedDays?: number[], dayAvailability?: string[], fullDate?: boolean, sx?: SxProps<Theme> }) => {
  const { day, outsideCurrentMonth, dayAvailability, fullDate, ...other } = props;

  const checkValid = (date: Dayjs) => {
    return (dayAvailability && dayAvailability.includes(dayjs(date).format('YYYY-MM-DD'))) || fullDate;
  }

  const isValid = checkValid(day);

  return (
    <Badge
      key={props.day.toString()}
      overlap='circular'
      sx={{ 
        ...sizeBoxCalendar,
        mt: '7px',
        '& .MuiButtonBase-root': { ...sizeBoxCalendarSelected },
        ...props.sx
      }}
      // sx={{
      //   ...sizeBoxCalendar,
      //   '& .MuiButtonBase-root': { ...sizeBoxCalendar },
      //   '& .MuiButtonBase-root.MuiPickersDay-root:not(.Mui-selected)': {border: '1px solid #E6E9ED'},
      //   mt: '-1px',
      //   ml: '-1px'
      // }}
    >
      <PickersDay {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} disabled={!isValid}/>
    </Badge >
  );
}

export default ServerDay;